import axios from "src/utils/axios";
import { createSlice } from "@reduxjs/toolkit";
import { staleGuard } from "src/utils/staleGuard";

// Alertas de fichaje del día (AUSENTE, SIN_CHECKOUT, RETRASO_ENTRADA…)
// que se muestran en el TopBar (campana). Antes vivía en state LOCAL
// del `ScheduleAlertsBadge` con `useState`, pero al haber DOS hooks
// consumidores concurrentes (`AlertsCenter` para el badge total +
// `ScheduleAlertsPanel` para el detalle de la tab), el `staleGuard`
// dejaba a uno de los dos con datos y al otro vacío (el segundo hook
// veía la key ya marcada y saltaba el fetch).
//
// Con el store centralizado ambos consumidores leen del MISMO array —
// una sola carga, dos suscriptores. Y el bootstrap puede hidratarlo
// directamente sin round-trip adicional.

const initialState = {
  alertas: [],
  loading: false,
};

const slice = createSlice({
  name: "scheduleAlerts",
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
    },
    setScheduleAlerts(state, action) {
      state.alertas = action.payload || [];
      state.loading = false;
    },
    clearScheduleAlerts(state) {
      state.alertas = [];
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const { startLoading, setScheduleAlerts, clearScheduleAlerts } =
  slice.actions;

// Fetch on-demand. El bootstrap ya hidrata `alertas` en el arranque; este
// thunk solo se usa cuando el consumidor monta fuera de ese flujo (o tras
// un push SignalR de fichaje). Sigue usando `staleGuard` para colapsar
// remounts sucesivos (nav entre TPV/mesa).
function todayMadridIso() {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Madrid",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date());
  const y = parts.find((p) => p.type === "year").value;
  const m = parts.find((p) => p.type === "month").value;
  const d = parts.find((p) => p.type === "day").value;
  return `${y}-${m}-${d}`;
}

export function fetchScheduleAlerts({ force = false } = {}) {
  return async (dispatch) => {
    // `force: true` para eventos SignalR (`schedule-alerts/{id}` desde
    // NotificationHub) — sin él, el TTL de 5 min descartaría el aviso
    // y el badge de alertas de fichaje quedaría congelado hasta remount.
    if (!force && staleGuard("schedule/dashboard")) return;
    const today = todayMadridIso();
    const desde = `${today}T00:00:00`;
    const hasta = `${today}T23:59:59`;
    try {
      dispatch(startLoading());
      const res = await axios.get("/employeeScheduleConfig/dashboard", {
        params: { desde, hasta },
      });
      dispatch(setScheduleAlerts(res.data?.alertas ?? []));
    } catch (_) {
      // Silencio: el badge se queda con las últimas alertas conocidas.
      dispatch(setScheduleAlerts([]));
    }
  };
}
